import React from 'react';

export const LoadingSpinner = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style="margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;"
    width="24px"
    height="24px"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <g transform="rotate(0 50 50)">
      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#ffffff">
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.9166666666666666s"
          repeatCount="indefinite"
        ></animate>
      </rect>
    </g>
    <g transform="rotate(30 50 50)">
      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#ffffff">
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.8333333333333334s"
          repeatCount="indefinite"
        ></animate>
      </rect>
    </g>
    <g transform="rotate(60 50 50)">
      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#ffffff">
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.75s"
          repeatCount="indefinite"
        ></animate>
      </rect>
    </g>
    <g transform="rotate(90 50 50)">
      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#ffffff">
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.6666666666666666s"
          repeatCount="indefinite"
        ></animate>
      </rect>
    </g>
    <g transform="rotate(120 50 50)">
      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#ffffff">
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.5833333333333334s"
          repeatCount="indefinite"
        ></animate>
      </rect>
    </g>
    <g transform="rotate(150 50 50)">
      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#ffffff">
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.5s"
          repeatCount="indefinite"
        ></animate>
      </rect>
    </g>
    <g transform="rotate(180 50 50)">
      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#ffffff">
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.4166666666666667s"
          repeatCount="indefinite"
        ></animate>
      </rect>
    </g>
    <g transform="rotate(210 50 50)">
      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#ffffff">
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.3333333333333333s"
          repeatCount="indefinite"
        ></animate>
      </rect>
    </g>
    <g transform="rotate(240 50 50)">
      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#ffffff">
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.25s"
          repeatCount="indefinite"
        ></animate>
      </rect>
    </g>
    <g transform="rotate(270 50 50)">
      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#ffffff">
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.16666666666666666s"
          repeatCount="indefinite"
        ></animate>
      </rect>
    </g>
    <g transform="rotate(300 50 50)">
      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#ffffff">
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="-0.08333333333333333s"
          repeatCount="indefinite"
        ></animate>
      </rect>
    </g>
    <g transform="rotate(330 50 50)">
      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#ffffff">
        <animate
          attributeName="opacity"
          values="1;0"
          keyTimes="0;1"
          dur="1s"
          begin="0s"
          repeatCount="indefinite"
        ></animate>
      </rect>
    </g>
  </svg>
);

export const Timer = () => (
  <svg
    width="28px"
    height="31px"
    viewBox="0 0 28 31"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Atto-/-Product-/-Time-Tracking" transform="translate(-316.000000, -6723.000000)">
        <g id="Group-14" transform="translate(150.000000, 6499.000000)">
          <g id="Group-27" transform="translate(0.000000, 220.000000)">
            <g id="OVAL-/-Grey-Normal" transform="translate(160.000000, 0.000000)">
              <g id="All_featres_time_tracking" transform="translate(6.000000, 4.000000)">
                <circle id="Oval-9" stroke="#00B9CB" strokeWidth="2" cx="14" cy="17" r="13" />
                <g id="Group" transform="translate(12.000000, 10.000000)" fill="#00B9CB">
                  <circle id="Oval-9" cx="2" cy="7" r="2" />
                  <path
                    d="M2,0 C2.55228475,-1.01453063e-16 3,0.44771525 3,1 L3,7 C3,7.55228475 2.55228475,8 2,8 C1.44771525,8 1,7.55228475 1,7 L1,1 C1,0.44771525 1.44771525,1.01453063e-16 2,0 Z"
                    id="Rectangle-4"
                    transform="translate(2.000000, 4.000000) scale(-1, 1) translate(-2.000000, -4.000000) "
                  />
                </g>
                <rect
                  id="Rectangle-11"
                  fill="#00B9CB"
                  transform="translate(14.000000, 1.000000) rotate(-270.000000) translate(-14.000000, -1.000000) "
                  x="13"
                  y="-3"
                  width="2"
                  height="8"
                  rx="1"
                />
                <path
                  d="M14,0 C14.4142136,-7.6089797e-17 14.75,0.335786438 14.75,0.75 L14.75,3.25 C14.75,3.66421356 14.4142136,4 14,4 C13.5857864,4 13.25,3.66421356 13.25,3.25 L13.25,0.75 C13.25,0.335786438 13.5857864,7.6089797e-17 14,0 Z"
                  id="Rectangle-4"
                  fill="#00B9CB"
                  transform="translate(14.000000, 2.000000) scale(-1, 1) translate(-14.000000, -2.000000) "
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Geofencing = () => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Atto-/-Product-/-Time-Tracking" transform="translate(-703.000000, -6725.000000)">
        <g id="Group-14" transform="translate(150.000000, 6499.000000)">
          <g id="Group-27" transform="translate(0.000000, 220.000000)">
            <g id="Single-Feature" transform="translate(390.000000, 0.000000)">
              <g id="OVAL-/-Grey-Normal" transform="translate(160.000000, 0.000000)">
                <g id="All_featres_Named-Locations" transform="translate(3.000000, 6.000000)">
                  <path
                    d="M23.7748603,-0.869220266 L23.8806209,-0.85840874 C24.055042,-0.826982331 24.2174743,-0.729016514 24.3265756,-0.571960156 L24.3265756,-0.571960156 L24.4503376,16.4396424 C24.4503376,16.6308747 24.3728254,16.804003 24.2475051,16.9293233 C24.1221848,17.0546435 23.9490565,17.1321557 23.7578242,17.1321557 L23.7578242,17.1321557 L10.7893156,17.1321557 C10.5980833,17.1321557 10.4249549,17.0546435 10.2996347,16.9293233 C10.1743144,16.804003 10.0968022,16.6308747 10.0968022,16.4396424 L10.0968022,16.4396424 L10.0968022,-0.176869495 C10.0968022,-0.368101781 10.1743144,-0.541230123 10.2996347,-0.666550394 C10.4249549,-0.791870665 10.5980833,-0.869382864 10.7893156,-0.869382864 L10.7893156,-0.869382864 L17.2735699,3.48429708 L23.3627335,-0.745620878 C23.5197899,-0.854722152 23.7061998,-0.88983515 23.8806209,-0.85840874 Z"
                    id="Rectangle-20"
                    stroke="#00B9CB"
                    strokeWidth="1.90909091"
                    transform="translate(17.273570, 8.131313) rotate(-270.000000) translate(-17.273570, -8.131313) "
                  />
                  <path
                    d="M8.96524064,0 L9.22727273,0 L9.22727273,0 L9.22727273,26.6919192 C9.22727273,27.2191001 8.79990817,27.6464646 8.27272727,27.6464646 C7.74554638,27.6464646 7.31818182,27.2191001 7.31818182,26.6919192 L7.31818182,1.64705882 C7.31818182,0.737413353 8.05559517,1.27732219e-15 8.96524064,0 Z"
                    id="Rectangle"
                    fill="#00B9CB"
                  />
                  <path
                    d="M8.27272727,27.997686 C7.21836548,27.997686 6.36363636,27.1434749 6.36363636,26.0897521 C6.36363636,25.0360293 7.21836548,24.1818182 8.27272727,24.1818182 C9.32708907,24.1818182 10.1818182,25.0360293 10.1818182,26.0897521 C10.1818182,27.1434749 9.32708907,27.997686 8.27272727,27.997686 Z"
                    id="Combined-Shape"
                    fill="#00B9CB"
                  />
                  <path
                    d="M14.9545455,27.0442975 C14.4273646,27.0442975 14,26.617192 14,26.0903306 C14,25.5634692 14.4273646,25.1363636 14.9545455,25.1363636 C15.4817264,25.1363636 15.9090909,25.5634692 15.9090909,26.0903306 C15.9090909,26.617192 15.4817264,27.0442975 14.9545455,27.0442975 Z"
                    id="Combined-Shape"
                    fill="#00B9CB"
                  />
                  <path
                    d="M1.59090909,27.0442975 C1.06372819,27.0442975 0.636363636,26.617192 0.636363636,26.0903306 C0.636363636,25.5634692 1.06372819,25.1363636 1.59090909,25.1363636 C2.11808999,25.1363636 2.54545455,25.5634692 2.54545455,26.0903306 C2.54545455,26.617192 2.11808999,27.0442975 1.59090909,27.0442975 Z"
                    id="Combined-Shape"
                    fill="#00B9CB"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Notification = () => (
  <svg
    width="26px"
    height="30px"
    viewBox="0 0 26 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Notification</title>
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Atto-/-Product-/-Time-Tracking"
        transform="translate(-1097.000000, -6724.000000)"
        fill="#00B9CB"
        fillRule="nonzero"
      >
        <g id="Group-14" transform="translate(150.000000, 6499.000000)">
          <g id="Group-27" transform="translate(0.000000, 220.000000)">
            <g id="Single-Feature" transform="translate(780.000000, 0.000000)">
              <g id="OVAL-/-Grey-Normal" transform="translate(160.000000, 0.000000)">
                <g id="All_featres_notifications" transform="translate(7.500000, 5.500000)">
                  <path
                    d="M13.1026565,0.150248842 C13.9957731,0.321395328 14.7628661,0.800273217 15.3037977,1.46335851 C15.8450292,2.12681131 16.1598508,2.97467455 16.147952,3.88321405 C17.6920281,5.05558012 18.9485206,6.2417494 19.8236759,7.69782927 C20.6336874,9.04330343 21.0874253,10.5720495 21.1442427,12.1392598 L21.15029,12.5015406 L21.150296,14.4386838 C21.1411156,15.2748882 21.4078706,16.0901 21.9024674,16.7607194 L22.0429702,16.9399378 L24.124361,19.4400242 C24.5391811,19.9327696 24.7916469,20.5238087 24.8719927,21.1373605 C24.9523623,21.7510942 24.860511,22.3873565 24.5863581,22.9709301 C24.3135101,23.562319 23.8799533,24.0470253 23.3518381,24.3826579 C22.8900389,24.6761448 22.3559319,24.8556471 21.7932598,24.8927907 L21.5504933,24.8999109 L3.45406835,24.8999111 C2.80396849,24.8986833 2.18293436,24.710099 1.65536045,24.3747805 C1.12809087,24.0396555 0.694170727,23.5579605 0.417945951,22.9703024 C0.141668026,22.3813739 0.0479509926,21.739719 0.127025736,21.1202626 C0.196244366,20.578017 0.397863609,20.0527845 0.725296978,19.5948404 L0.873309268,19.4028449 L2.94934767,16.9033268 C3.47804678,16.2692655 3.78760496,15.4835484 3.83552646,14.6639962 L3.84207718,14.4397316 L3.84207708,12.5016331 C3.84448986,10.8085682 4.30356432,9.14937211 5.17604475,7.70015405 C6.04851062,6.24854881 7.29794582,5.06270077 8.79150536,4.26563881 C8.84442369,2.68647601 9.31459705,1.65945394 10.1377511,0.963213212 C10.9580261,0.269413659 12.0445292,-0.0275531889 13.1026565,0.150248842 Z M12.4962423,2.40297076 C12.1771509,2.40297076 11.8686147,2.51627282 11.6260169,2.71919632 C11.3197013,2.97781154 11.1456307,3.35474054 11.1456307,3.75277246 L11.1456307,3.75277246 L11.1456307,5.00260541 L11.1365709,5.14616786 C11.1126244,5.33493761 11.0420622,5.51195067 10.9351047,5.66317522 C10.8011274,5.8526025 10.6100322,6.00159567 10.3817689,6.08250712 C9.17341283,6.51191907 8.11190104,7.41634383 7.35354492,8.56604582 C6.59765949,9.71200213 6.1432842,11.1009711 6.1432842,12.5015406 L6.1432842,12.5015406 L6.1432842,14.4397816 L6.13613243,14.7263121 C6.07174168,16.0598189 5.57480403,17.337818 4.71565373,18.3668456 L4.71565373,18.3668456 L2.63932837,20.8667084 L2.56586705,20.9638308 C2.47628309,21.0981222 2.42032808,21.2504858 2.4000541,21.4076299 C2.37471223,21.6040554 2.40512763,21.8079461 2.49440688,21.9943178 C2.57878076,22.1804127 2.71618938,22.3345645 2.88407004,22.4406419 C3.05158858,22.5464905 3.24943079,22.6044712 3.45603709,22.6005217 L3.45603709,22.6005217 L21.5507396,22.60054 L21.6720808,22.5942206 C21.8320169,22.5765137 21.9836588,22.5222541 22.116375,22.4382978 C22.2827935,22.3330214 22.4194466,22.1810441 22.505987,21.995904 C22.5934811,21.8102502 22.6225444,21.6081833 22.5967875,21.4134814 C22.5709518,21.2181841 22.4899454,21.0302751 22.3574265,20.8735112 L22.3574265,20.8735112 L20.2768712,18.3744215 L20.0978737,18.1496568 C19.2888174,17.0835003 18.8491505,15.780522 18.8491505,14.4399378 L18.8491505,14.4399378 L18.8491505,12.5016969 L18.8458196,12.2019727 C18.8032966,10.9079757 18.3976633,9.67960213 17.70881,8.63870307 C16.9670856,7.51791275 15.8969971,6.61447798 14.5982759,6.07945643 C14.370395,5.99399037 14.1831858,5.84451655 14.0522319,5.65626305 C13.9214738,5.46829102 13.846804,5.24164197 13.846804,5.00263666 L13.846804,5.00263666 L13.8466509,3.73247492 C13.8298309,3.43071003 13.7142332,3.14590067 13.5053629,2.9151395 C13.2817608,2.66810259 12.9498962,2.48217431 12.4962423,2.40297076 Z"
                    id="Combined-Shape"
                    stroke="#FFFFFF"
                    strokeWidth="0.2"
                  />
                  <rect id="Rectangle" x="7.5" y="27" width="10" height="2" rx="1" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const ManualEntries = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Manual Entries</title>
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Atto-/-Product-/-Time-Tracking"
        transform="translate(-310.000000, -6979.000000)"
        fillRule="nonzero"
      >
        <g id="Group-14" transform="translate(150.000000, 6499.000000)">
          <g id="Group-27" transform="translate(0.000000, 220.000000)">
            <g id="Group-38" transform="translate(0.000000, 260.000000)">
              <g id="OVAL-/-Grey-Normal" transform="translate(160.000000, 0.000000)">
                <g id="All_featres_Manual-Entries" transform="translate(5.000000, 5.000000)">
                  <polygon
                    id="M"
                    fill="#00B9CB"
                    points="11.4503497 21 11.4167832 14.4352941 14.2867133 19.1823529 14.2867133 19.2 15.7132867 19.2 18.5664336 14.4882353 18.5664336 21 21 21 21 9 19.2713287 9 15.0083916 16.0588235 10.7454545 9 9 9 9 21"
                  />
                  <circle id="Oval" stroke="#00B9CB" strokeWidth="2" cx="15" cy="15" r="15" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const TimeOff = () => (
  <svg
    width="28px"
    height="32px"
    viewBox="0 0 28 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Time Off</title>
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Atto-/-Product-/-Time-Tracking"
        transform="translate(-706.000000, -6983.000000)"
        fill="#00B9CB"
        fillRule="nonzero"
        stroke="#00B9CB"
        strokeWidth="0.3"
      >
        <g id="Group-14" transform="translate(150.000000, 6499.000000)">
          <g id="Group-27" transform="translate(0.000000, 220.000000)">
            <g id="Group-38" transform="translate(0.000000, 260.000000)">
              <g id="Single-Feature" transform="translate(390.000000, 0.000000)">
                <g id="OVAL-/-Grey-Normal" transform="translate(160.000000, 0.000000)">
                  <g id="All_featres_time_off" transform="translate(7.000000, 5.000000)">
                    <path
                      d="M13.0000571,23.5308511 C13.2741864,23.5308511 13.5226399,23.6444129 13.7024443,23.8284969 C13.8809864,24.0112885 13.9917264,24.2637003 13.9917264,24.5425532 L13.9917264,24.5425532 L13.9917264,29.1382979 C13.9917264,29.4171507 13.8809864,29.6695626 13.7024443,29.8523542 C13.5226399,30.0364382 13.2741864,30.15 13.0000571,30.15 C12.7259277,30.15 12.4774742,30.0364382 12.2976698,29.8523542 C12.1191277,29.6695626 12.0083877,29.4171507 12.0083877,29.1382979 L12.0083877,29.1382979 L12.0083877,24.5425532 C12.0083877,24.2637003 12.1191277,24.0112885 12.2976698,23.8284969 C12.4774742,23.6444129 12.7259277,23.5308511 13.0000571,23.5308511 Z M4.79784803,19.5095894 C5.11748076,19.530358 5.41671388,19.7104125 5.58972715,20.0167313 C5.72576276,20.2578403 5.75372346,20.5324675 5.68869797,20.781633 C5.62346124,21.031608 5.46476303,21.2557454 5.2285912,21.3954173 L5.2285912,21.3954173 L1.34454511,23.693303 C1.10700442,23.8337811 0.833820326,23.8626079 0.585788289,23.7952735 C0.338858324,23.7282382 0.116886052,23.5658893 -0.0197460758,23.323723 C-0.155536988,23.0830476 -0.181505829,22.8090298 -0.114683185,22.5600791 C-0.0474587044,22.3096313 0.113678601,22.084882 0.350143243,21.945037 L0.350143243,21.945037 L4.23370588,19.6474384 Z M21.2427396,19.5077986 L25.6498433,21.9450135 C25.8863274,22.0848846 26.0474625,22.309632 26.1146856,22.5600747 C26.1815063,22.8090185 26.1555386,23.083027 26.0197489,23.3237071 C25.883117,23.5658796 25.6611453,23.7282298 25.4142162,23.7952649 C25.1661831,23.8625996 24.8929974,23.83377 24.6554342,23.6932753 L24.6554342,23.6932753 L20.7714281,21.3954132 C20.53523,21.2557162 20.3765329,21.0315793 20.3112976,20.7816098 C20.2462728,20.5324469 20.2742361,20.2578255 20.4103068,20.01666 C20.5905788,19.6974715 20.9079969,19.5153675 21.2427396,19.5077986 L21.2427396,19.5077986 Z M13.0000571,9.39255319 C14.5086172,9.39255319 15.8793693,10.0230204 16.8728164,11.0401128 C17.8649985,12.0559101 18.4806296,13.4573273 18.4806296,15 C18.4806296,16.5426727 17.8649985,17.9440899 16.8728164,18.9598872 C15.8793693,19.9769796 14.5086172,20.6074468 13.0000571,20.6074468 C11.4914969,20.6074468 10.1207449,19.9769796 9.12729775,18.9598872 C8.13511563,17.9440899 7.51948454,16.5426727 7.51948454,15 C7.51948454,13.4573273 8.13511563,12.0559101 9.12729775,11.0401128 C10.1207449,10.0230204 11.4914969,9.39255319 13.0000571,9.39255319 Z M13.0000571,11.4159574 C12.0300014,11.4159574 11.1561037,11.8142185 10.5246866,12.460664 C9.89201175,13.1083974 9.50282323,14.0050408 9.50282323,15 C9.50282323,15.9949592 9.89201175,16.8916026 10.5246866,17.539336 C11.1561037,18.1857815 12.0300014,18.5840426 13.0000571,18.5840426 C13.9701127,18.5840426 14.8440104,18.1857815 15.4754275,17.539336 C16.1081024,16.8916026 16.4972909,15.9949592 16.4972909,15 C16.4972909,14.0050408 16.1081024,13.1083974 15.4754275,12.460664 C14.8440104,11.8142185 13.9701127,11.4159574 13.0000571,11.4159574 Z M0.821480814,6.16737784 L5.22857383,8.6045868 C5.46477574,8.74428608 5.62347976,8.96842521 5.68871587,9.2183978 C5.75373969,9.46755695 5.72577515,9.74217448 5.58972422,9.98328827 C5.45287939,10.2258091 5.2329039,10.3879994 4.98824078,10.4549255 C4.74264616,10.5221064 4.47189882,10.4934444 4.23416671,10.3528497 L4.23416671,10.3528497 L0.350158632,8.0549865 C0.113674367,7.91511534 -0.0474624648,7.69036444 -0.114686086,7.43991985 C-0.18150759,7.19097336 -0.155538772,6.91696406 -0.0197139733,6.67623452 C0.160238565,6.35761149 0.48802713,6.17481692 0.821480814,6.16737784 L0.821480814,6.16737784 Z M25.200405,6.16813229 C25.5262361,6.18289518 25.8436891,6.36459474 26.019748,6.67630575 C26.1555389,6.91698107 26.1815077,7.19099891 26.1146851,7.43994964 C26.0474606,7.69039744 25.8863233,7.91514669 25.6498587,8.05499176 L25.6498587,8.05499176 L21.7658126,10.3528775 C21.5281025,10.4934557 21.2573478,10.522115 21.0117497,10.4549331 C20.7670801,10.3880053 20.5471041,10.2258133 20.4102747,9.98329744 C20.2742391,9.74218842 20.2462784,9.46756127 20.3113039,9.21839572 C20.3765407,8.96842072 20.5352389,8.74428333 20.7714107,8.60461143 L20.7714107,8.60461143 L24.6747373,6.29531893 Z M12.9997765,-0.15 C13.2739059,-0.15 13.5223593,-0.0364382045 13.7021638,0.147645819 C13.8807059,0.330437434 13.9914458,0.582849258 13.9914458,0.861702128 L13.9914458,0.861702128 L13.9914458,5.45744681 C13.9914458,5.73629968 13.8807059,5.9887115 13.7021638,6.17150312 C13.5223593,6.35558714 13.2739059,6.46914894 12.9997765,6.46914894 C12.7256471,6.46914894 12.4771937,6.35558714 12.2973892,6.17150312 C12.1188471,5.9887115 12.0081072,5.73629968 12.0081072,5.45744681 L12.0081072,5.45744681 L12.0081072,0.861702128 C12.0081072,0.582849258 12.1188471,0.330437434 12.2973892,0.147645819 C12.4771937,-0.0364382045 12.7256471,-0.15 12.9997765,-0.15 L12.9997765,-0.15 Z"
                      id="Paid-Time-Off"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const Notes = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Notes</title>
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Atto-/-Product-/-Time-Tracking" transform="translate(-1090.000000, -6979.000000)">
        <g id="Group-14" transform="translate(150.000000, 6499.000000)">
          <g id="Group-27" transform="translate(0.000000, 220.000000)">
            <g id="Group-38" transform="translate(0.000000, 260.000000)">
              <g id="Single-Feature" transform="translate(780.000000, 0.000000)">
                <g id="OVAL-/-Grey-Normal" transform="translate(160.000000, 0.000000)">
                  <g id="All_featres_Notes" transform="translate(6.000000, 6.000000)">
                    <polyline
                      id="Path-2"
                      stroke="#00B9CB"
                      strokeWidth="1.90909091"
                      strokeLinejoin="round"
                      points="17.7901476 27.1234809 17.7901476 17.7901476 27.1234809 17.7901476"
                    />
                    <path
                      d="M7.17676768,6.22222222 L20.8232323,6.22222222 C21.3504132,6.22222222 21.7777778,6.64958678 21.7777778,7.17676768 C21.7777778,7.70394857 21.3504132,8.13131313 20.8232323,8.13131313 L7.17676768,8.13131313 C6.64958678,8.13131313 6.22222222,7.70394857 6.22222222,7.17676768 C6.22222222,6.64958678 6.64958678,6.22222222 7.17676768,6.22222222 Z"
                      id="Rectangle-23"
                      fill="#00B9CB"
                    />
                    <path
                      d="M7.17676768,10.8888889 L20.8232323,10.8888889 C21.3504132,10.8888889 21.7777778,11.3162534 21.7777778,11.8434343 C21.7777778,12.3706152 21.3504132,12.7979798 20.8232323,12.7979798 L7.17676768,12.7979798 C6.64958678,12.7979798 6.22222222,12.3706152 6.22222222,11.8434343 C6.22222222,11.3162534 6.64958678,10.8888889 7.17676768,10.8888889 Z"
                      id="Rectangle-23"
                      fill="#00B9CB"
                    />
                    <path
                      d="M24.8888889,0.954545452 C25.484408,0.954545452 26.0235495,1.19592728 26.4138111,1.58618891 C26.8040727,1.97645053 27.0454545,2.51559195 27.0454545,3.11111111 L27.0454545,3.11111111 L27.0454545,24.8888889 C27.0454545,25.484408 26.8040727,26.0235495 26.4138111,26.4138111 C26.0235495,26.8040727 25.484408,27.0454545 24.8888889,27.0454545 L24.8888889,27.0454545 L3.1111111,27.0454545 C2.51559194,27.0454545 1.97645053,26.8040727 1.5861889,26.4138111 C1.19592728,26.0235495 0.954545445,25.484408 0.954545445,24.8888889 L0.954545445,24.8888889 L0.954545445,10.6219978 C0.954545445,10.050041 1.18175439,9.50151006 1.5861889,9.09707555 L1.5861889,9.09707555 L9.09707554,1.58618891 C9.50151005,1.1817544 10.050041,0.954545452 10.6219977,0.954545452 L10.6219977,0.954545452 Z"
                      id="Rectangle-20"
                      stroke="#00B9CB"
                      strokeWidth="1.90909091"
                      transform="translate(14.000000, 14.000000) rotate(-180.000000) translate(-14.000000, -14.000000) "
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const OvertimeRules = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Overtime Rules</title>
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Atto-/-Product-/-Time-Tracking"
        transform="translate(-310.000000, -7239.000000)"
        stroke="#00B9CB"
      >
        <g id="Group-14" transform="translate(150.000000, 6499.000000)">
          <g id="Group-27" transform="translate(0.000000, 220.000000)">
            <g id="Group-37" transform="translate(0.000000, 520.000000)">
              <g id="OVAL-/-Grey-Normal" transform="translate(160.000000, 0.000000)">
                <g
                  id="All_featres_overtime"
                  transform="translate(20.000000, 20.000000) scale(1, -1) translate(-20.000000, -20.000000) translate(5.000000, 5.000000)"
                >
                  <line
                    x1="19.7368421"
                    y1="17.3684211"
                    x2="19.7368421"
                    y2="23.6842105"
                    id="Path-14"
                    strokeWidth="2.04545455"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    transform="translate(19.736842, 20.526316) rotate(-45.000000) translate(-19.736842, -20.526316) "
                  />
                  <path
                    d="M14.2105263,1 C17.8585124,1 21.161144,2.47863852 23.5517791,4.86927358 C25.7219489,7.03944341 27.1405753,9.96115666 27.3837714,13.2105263 L27.3837714,13.2105263 L13.2105263,13.2105263 L13.2105263,27.3837714 C9.96115666,27.1405753 7.03944341,25.7219489 4.86927358,23.5517791 C2.47863852,21.161144 1,17.8585124 1,14.2105263 C1,10.5625402 2.47863852,7.25990863 4.86927358,4.86927358 C7.25990863,2.47863852 10.5625402,1 14.2105263,1 Z"
                    id="Oval"
                    strokeWidth="2"
                  />
                  <path
                    d="M30,22.9824561 L30,17.3684211 C23.0237716,17.3684211 17.3684211,23.0237716 17.3684211,30 L23.6095121,30"
                    id="Oval"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    transform="translate(23.684211, 23.684211) scale(-1, -1) translate(-23.684211, -23.684211) "
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const BreakPreferences = () => (
  <svg
    width="28px"
    height="30px"
    viewBox="0 0 28 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Break Preferences</title>
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Atto-/-Product-/-Time-Tracking" transform="translate(-707.000000, -7245.000000)">
        <g id="Group-14" transform="translate(150.000000, 6499.000000)">
          <g id="Group-27" transform="translate(0.000000, 220.000000)">
            <g id="Group-37" transform="translate(0.000000, 520.000000)">
              <g id="Single-Feature" transform="translate(390.000000, 0.000000)">
                <g id="OVAL-/-Grey-Normal" transform="translate(160.000000, 0.000000)">
                  <g id="All_featres_Break" transform="translate(7.000000, 6.000000)">
                    <path
                      d="M20.4604143,10.9782609 L20.7608696,13.9285714 C20.7608696,16.9225634 19.6468541,19.6360479 17.8363885,21.5991099 C16.0534229,23.532354 13.5925384,24.7360248 10.8695652,24.7360248 C8.14659202,24.7360248 5.68570749,23.532354 3.90274193,21.5991099 C2.09227633,19.6360479 0.97826087,16.9225634 0.97826087,13.9285714 L0.97826087,13.9285714 L0.97826087,11.2651173 L20.4604143,10.9782609 Z"
                      id="Oval-5"
                      stroke="#00B9CB"
                      strokeWidth="1.95652174"
                    />
                    <g id="Group-11" transform="translate(6.521739, 0.000000)" fill="#00B9CB">
                      <rect
                        id="Rectangle"
                        x="0.724637681"
                        y="2.85714286"
                        width="1.95652174"
                        height="5.71428571"
                        rx="0.97826087"
                      />
                      <rect
                        id="Rectangle"
                        x="6.52173913"
                        y="2.85714286"
                        width="1.95652174"
                        height="5.71428571"
                        rx="0.97826087"
                      />
                      <rect
                        id="Rectangle"
                        x="3.62318841"
                        y="-5.61869392e-14"
                        width="1.95652174"
                        height="5.71428571"
                        rx="0.97826087"
                      />
                    </g>
                    <path
                      d="M5.32608696,27.1428571 L16.4130435,27.1428571 C16.953322,27.1428571 17.3913043,27.5808395 17.3913043,28.121118 C17.3913043,28.6613966 16.953322,29.0993789 16.4130435,29.0993789 L5.32608696,29.0993789 C4.7858084,29.0993789 4.34782609,28.6613966 4.34782609,28.121118 C4.34782609,27.5808395 4.7858084,27.1428571 5.32608696,27.1428571 Z"
                      id="Rectangle-22"
                      fill="#00B9CB"
                    />
                    <path
                      d="M20,11.3043478 L22.6112119,11.3043478 C24.5308126,11.3043478 26.0869565,12.9033309 26.0869565,14.8757764 C26.0869565,16.8482219 24.5308126,18.447205 22.6112119,18.447205 L20.0869565,18.447205"
                      id="Oval-5"
                      stroke="#00B9CB"
                      strokeWidth="1.95652174"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const JobCodes = () => (
  <svg
    width="20px"
    height="30px"
    viewBox="0 0 20 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Job Codes</title>
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Atto-/-Product-/-Time-Tracking" transform="translate(-1100.000000, -7244.000000)">
        <g id="Group-14" transform="translate(150.000000, 6499.000000)">
          <g id="Group-27" transform="translate(0.000000, 220.000000)">
            <g id="Group-37" transform="translate(0.000000, 520.000000)">
              <g id="Single-Feature" transform="translate(780.000000, 0.000000)">
                <g id="OVAL-/-Grey-Normal" transform="translate(160.000000, 0.000000)">
                  <g id="All_featres_Jobs" transform="translate(10.000000, 5.000000)">
                    <path
                      d="M15.334128,1.41871447 C15.8630531,1.05074406 16.4910544,0.931998648 17.078817,1.03747711 C17.6665796,1.14295557 18.2141035,1.47265792 18.5820739,2.00158303 C18.8541574,2.39267905 19,2.8576918 19,3.33412174 L19,3.33412174 L19,26.6666667 C19,27.3109989 18.7388328,27.8943322 18.3165825,28.3165825 C17.8943322,28.7388328 17.3109989,29 16.6666667,29 L16.6666667,29 L3.33333333,29 C2.68900113,29 2.10566779,28.7388328 1.68341751,28.3165825 C1.26116723,27.8943322 1,27.3109989 1,26.6666667 L1,26.6666667 L1,3.33412174 C1,2.68978953 1.26116723,2.1064562 1.68341751,1.68420592 C2.10566779,1.26195564 2.68900113,1.00078841 3.33333333,1.00078841 C3.80976327,1.00078841 4.27477603,1.14663104 4.66587205,1.41871447 L4.66587205,1.41871447 L10,5.12963909 Z"
                      id="Rectangle-20"
                      stroke="#00B9CB"
                      strokeWidth="2"
                      transform="translate(10.000000, 15.000000) rotate(-180.000000) translate(-10.000000, -15.000000) "
                    />
                    <rect
                      id="Rectangle-25"
                      fill="#00B9CB"
                      x="1.66666667"
                      y="8.75"
                      width="16.6666667"
                      height="2"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const RoundedClockTimes = () => (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 30 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Rounded Clock</title>
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Atto-/-Product-/-Time-Tracking"
        transform="translate(-315.000000, -7504.000000)"
        fill="#00B9CB"
      >
        <g id="Group-14" transform="translate(150.000000, 6499.000000)">
          <g id="Group-27" transform="translate(0.000000, 220.000000)">
            <g id="Group-13" transform="translate(0.000000, 780.000000)">
              <g id="OVAL-/-Grey-Normal" transform="translate(160.000000, 0.000000)">
                <g id="All_featres_rounding" transform="translate(5.000000, 5.000000)">
                  <path
                    d="M18.1320207,20.3571429 C17.8366144,20.3571429 17.541208,20.2478461 17.315597,20.0292685 L14.6354072,17.4324443 C14.1799501,16.9911539 13.9285714,16.4030776 13.9285714,15.7786045 L13.9285714,8.6178273 C13.9285714,8.00062825 14.4452713,7.5 15.0822842,7.5 C15.7192972,7.5 16.235997,8.00062825 16.235997,8.6178273 L16.235997,15.7786045 C16.235997,15.8056649 16.2467386,15.8316862 16.2671492,15.8514619 L18.947339,18.4482861 C19.3985061,18.88542 19.3985061,19.5931845 18.947339,20.0292792 C18.7217527,20.2478487 18.4263491,20.3571429 18.1320152,20.3571429 L18.1320207,20.3571429 Z"
                    id="Fill-1"
                  />
                  <path
                    d="M16.5873333,1.57943333 C16.5873333,3.65236667 13.4792667,3.65236667 13.4792667,1.57943333 C13.4792667,-0.492166667 16.5873333,-0.492166667 16.5873333,1.57943333"
                    id="Fill-2"
                  />
                  <path
                    d="M29.974,15.034 C29.974,17.1056 26.8659333,17.1056 26.8659333,15.034 C26.8659333,12.9610667 29.974,12.9610667 29.974,15.034"
                    id="Fill-3"
                  />
                  <path
                    d="M3.134,14.966 C3.134,17.0389333 0.0259336667,17.0389333 0.0259336667,14.966 C0.0259336667,12.8944 3.134,12.8944 3.134,14.966"
                    id="Fill-4"
                  />
                  <path
                    d="M16.5206667,28.420667 C16.5206667,30.492267 13.4126,30.492267 13.4126,28.420667 C13.4126,26.3477333 16.5206667,26.3477333 16.5206667,28.420667"
                    id="Fill-5"
                  />
                  <path
                    d="M4.39466667,8.241 C4.39466667,9.56 2.4168,9.56 2.4168,8.241 C2.4168,6.9233 4.39466667,6.9233 4.39466667,8.241"
                    id="Fill-6"
                  />
                  <path
                    d="M9.254,3.341 C9.254,4.54023333 7.45323333,4.54023333 7.45323333,3.341 C7.45323333,2.14046667 9.254,2.14046667 9.254,3.341"
                    id="Fill-7"
                  />
                  <path
                    d="M22.7473333,3.405 C22.7473333,4.724 20.7694667,4.724 20.7694667,3.405 C20.7694667,2.0873 22.7473333,2.0873 22.7473333,3.405"
                    id="Fill-8"
                  />
                  <path
                    d="M27.6483333,8.354 C27.6483333,9.6717 25.6704667,9.6717 25.6704667,8.354 C25.6704667,7.035 27.6483333,7.035 27.6483333,8.354"
                    id="Fill-9"
                  />
                  <path
                    d="M27.5833333,21.759 C27.5833333,23.0767 25.6054667,23.0767 25.6054667,21.759 C25.6054667,20.44 27.5833333,20.44 27.5833333,21.759"
                    id="Fill-10"
                  />
                  <path
                    d="M22.6353333,26.659 C22.6353333,27.978 20.6574667,27.978 20.6574667,26.659 C20.6574667,25.34 22.6353333,25.34 22.6353333,26.659"
                    id="Fill-11"
                  />
                  <path
                    d="M9.23033333,26.595 C9.23033333,27.9127 7.25246667,27.9127 7.25246667,26.595 C7.25246667,25.276 9.23033333,25.276 9.23033333,26.595"
                    id="Fill-12"
                  />
                  <path
                    d="M4.32933333,21.646 C4.32933333,22.965 2.35146667,22.965 2.35146667,21.646 C2.35146667,20.3283 4.32933333,20.3283 4.32933333,21.646"
                    id="Fill-13"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const Timezones = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Timezones</title>
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Atto-/-Product-/-Time-Tracking"
        transform="translate(-700.000000, -7499.000000)"
        stroke="#00B9CB"
        strokeWidth="1.5"
      >
        <g id="Group-14" transform="translate(150.000000, 6499.000000)">
          <g id="Group-27" transform="translate(0.000000, 220.000000)">
            <g id="Group-13" transform="translate(0.000000, 780.000000)">
              <g id="Single-Feature-Copy-3" transform="translate(390.000000, 0.000000)">
                <g id="OVAL-/-Grey-Normal" transform="translate(160.000000, 0.000000)">
                  <g id="All_featres_time_zone" transform="translate(6.000000, 6.000000)">
                    <line x1="0" y1="14" x2="28" y2="14" id="Path-4" />
                    <line x1="14" y1="-9.90874049e-15" x2="14" y2="28" id="Path-14" />
                    <circle id="Oval" cx="14" cy="14" r="14" />
                    <ellipse id="Oval" cx="14" cy="14" rx="7" ry="14" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const NightShifts = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Night Shifts</title>
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Atto-/-Product-/-Time-Tracking"
        transform="translate(-1090.000000, -7499.000000)"
        stroke="#00B9CB"
        strokeWidth="2"
      >
        <g id="Group-14" transform="translate(150.000000, 6499.000000)">
          <g id="Group-27" transform="translate(0.000000, 220.000000)">
            <g id="Group-13" transform="translate(0.000000, 780.000000)">
              <g id="Single-Feature-Copy-5" transform="translate(780.000000, 0.000000)">
                <g id="OVAL-/-Grey-Normal" transform="translate(160.000000, 0.000000)">
                  <g id="All_featres_night_shift" transform="translate(5.000000, 5.000000)">
                    <circle id="Oval" cx="15" cy="15" r="15" />
                    <path
                      d="M16.905866,7.5107948 C15.1476562,8.75607878 14,10.8065147 14,13.125 C14,16.9219577 17.0780423,20 20.875,20 C21.3290473,20 21.7728143,19.9559845 22.2022668,19.8719877 C20.826681,21.4804727 18.7824022,22.5 16.5,22.5 C12.3578644,22.5 9,19.1421356 9,15 C9,10.8578644 12.3578644,7.5 16.5,7.5 C16.6361667,7.5 16.7714858,7.50362874 16.905866,7.5107948 Z"
                      id="Path"
                      strokeLinejoin="round"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const RealTimeLocationUpdates = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Real Time Location Updates</title>
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Atto-/-All-features"
        transform="translate(-231.000000, -2360.000000)"
        stroke="#00B9CB"
        strokeWidth="1.875"
      >
        <g id="Group-10" transform="translate(150.000000, 2182.000000)">
          <g id="Group-9" transform="translate(0.000000, 98.000000)">
            <g id="Group" transform="translate(81.000000, 80.000000)">
              <g id="All_featres_Location-Tracking" transform="translate(8.000000, 6.000000)">
                <path
                  d="M12.5,0.9375 C15.4602888,0.9375 18.4210513,2.05268544 20.6798563,4.2849162 C22.9343027,6.51283978 24.0625,9.43263999 24.0625,12.3529412 C24.0625,15.2732424 22.9343027,18.1930426 20.6798563,20.4209662 C17.6897577,23.3758871 14.9636808,25.7874392 12.4995819,27.6532239 C10.0359612,25.7871225 7.31004602,23.3756931 4.32014375,20.4209662 C2.06569727,18.1930426 0.9375,15.2732424 0.9375,12.3529412 C0.9375,9.43263999 2.06569727,6.51283978 4.32014375,4.2849162 C6.57894868,2.05268544 9.53971115,0.9375 12.5,0.9375 Z"
                  id="Oval-11"
                />
                <ellipse id="Oval-12" cx="12.5" cy="12.3529412" rx="4.50892857" ry="4.46691176" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const ClockInOutHistories = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Real Time Location Updates</title>
    <g
      id="WEB-DESIGN"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <g
        id="Atto-/-All-features"
        transform="translate(-761.000000, -2360.000000)"
        stroke="#00B9CB"
        strokeWidth="2"
      >
        <g id="Group-10" transform="translate(150.000000, 2182.000000)">
          <g id="Group-9" transform="translate(0.000000, 98.000000)">
            <g id="Group" transform="translate(81.000000, 80.000000)">
              <g id="Group" transform="translate(530.000000, 0.000000)">
                <g
                  id="All_featres_Location-Tracking"
                  transform="translate(21.669417, 20.411765) scale(-1, 1) translate(-21.669417, -20.411765) translate(11.000000, 6.000000)"
                  strokeLinejoin="round"
                >
                  <path
                    d="M21.3388348,21.0877896 C18.0844657,24.3038721 15.1381874,26.882452 12.5,28.8235294 C9.86181259,26.882452 6.91553433,24.3038721 3.66116523,21.0877896 C-1.22038841,16.263666 -1.22038841,8.44221631 3.66116523,3.6180927 C8.54271888,-1.2060309 16.4572811,-1.2060309 21.3388348,3.6180927"
                    id="Oval-11"
                  />
                </g>
                <g id="Group-2" transform="translate(19.300000, 12.200000)">
                  <line
                    x1="3.75"
                    y1="3.25"
                    x2="-2.75"
                    y2="3.25"
                    id="Line"
                    transform="translate(0.500000, 3.250000) rotate(-90.000000) translate(-0.500000, -3.250000) "
                  />
                  <line
                    x1="6.2513456"
                    y1="9.0486544"
                    x2="-0.251345597"
                    y2="9.0513456"
                    id="Line"
                    transform="translate(3.000000, 9.050000) rotate(225.000000) translate(-3.000000, -9.050000) "
                  />
                </g>
                <g
                  transform="translate(12.650000, 8.565291) rotate(-90.000000) translate(-12.650000, -8.565291) translate(9.884709, 5.315291)"
                  id="Line"
                >
                  <line x1="5.53058262" y1="0.5" x2="0.530582618" y2="0.5" />
                  <line
                    x1="3.33883476"
                    y1="3.5"
                    x2="-1.66116524"
                    y2="3.5"
                    transform="translate(0.500000, 3.500000) rotate(-90.000000) translate(-0.500000, -3.500000) "
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const NamedJobSites = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>3429C9F3-56F3-429F-AA75-277EC13B2DC3SVG</title>
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Atto-/-All-features"
        transform="translate(-231.000000, -2580.000000)"
        stroke="#00B9CB"
        strokeWidth="1.7"
      >
        <g id="Group-10" transform="translate(150.000000, 2182.000000)">
          <g id="Group-9" transform="translate(0.000000, 98.000000)">
            <g id="Group" transform="translate(81.000000, 300.000000)">
              <g id="Group" transform="translate(9.000000, 5.000000)">
                <path
                  d="M11,1.0982518 L21.15,9.40279726 L21.15,24 C21.15,25.4221332 20.5735666,26.7096332 19.6415999,27.6415999 C18.7096332,28.5735666 17.4221332,29.15 16,29.15 L16,29.15 L6,29.15 C4.57786677,29.15 3.29036677,28.5735666 2.35840008,27.6415999 C1.42643338,26.7096332 0.85,25.4221332 0.85,24 L0.85,24 L0.85,9.40279726 L11,1.0982518 Z"
                  id="Rectangle"
                />
                <circle id="Oval" cx="11" cy="10" r="2.15" />
                <line
                  x1="4.5"
                  y1="18.5"
                  x2="17.5"
                  y2="18.5"
                  id="Line-2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="4.5"
                  y1="22.5"
                  x2="17.5"
                  y2="22.5"
                  id="Line-2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const LocationHistoryTracking = () => {};
export const PrivacyControls = () => {};
export const BatteryEfficiency = () => {};
export const Timelines = () => {};
export const Departments = () => {};
export const EmployeeStatusOverview = () => {};
export const FilterSearch = () => {};
export const Messaging = () => {};
export const Timesheets = () => {};
export const EmailReports = () => {};
export const TeamJobTimesheets = () => {};
export const TimeEntryChangeHistory = () => {};
export const WageRates = () => {};
export const Payroll = () => {};
export const Download = () => {};
export const Archive = () => {};

export const HeartIcon = () => (
  <svg
    width="19px"
    height="17px"
    viewBox="0 0 19 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Heart Icon</title>
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Atto-/-Time-tracking-for-construction-companies"
        transform="translate(-161.000000, -4306.000000)"
        fill="#262626"
        stroke="#262626"
        strokeWidth="0.5"
      >
        <g id="Group-37" transform="translate(150.000000, 4103.000000)">
          <g id="Group-24" transform="translate(0.000000, 1.000000)">
            <g id="Group-14" transform="translate(0.000000, 170.000000)">
              <g id="subtittle-+" transform="translate(0.000000, 2.000000)">
                <g id="Group" transform="translate(0.000000, 18.000000)">
                  <g id="Employees-will-love" transform="translate(11.000000, 12.000000)">
                    <path
                      d="M17.05535,2.125 C15.02507,0.09472 11.7,0.025 9.6,2.019727 C7.5,0.059167 4.2107,0.094727 2.14465,2.125 C0.08021,4.18944 0.04465,7.55 2.109104,9.65 L2.14465,9.685546 L8.2,15.739496 C8.58556,16.125056 9.11056,16.334216 9.6,16.334216 C10.125,16.334216 10.61444,16.12367 11,15.739496 L17.05535,9.684146 C19.11979,7.585511 19.11979,4.224846 17.05535,2.124846 L17.05535,2.125 Z M16.11063,8.7393 L16.075084,8.774846 L10.055434,14.760546 C9.810707,15.005273 9.390994,15.005273 9.144874,14.760546 L3.160574,8.774846 L3.125028,8.7393 C1.585588,7.19986 1.585588,4.64465 3.125028,3.1036 C4.664468,1.56416 7.185728,1.56416 8.760728,3.1036 L9.146288,3.48916 C9.285742,3.628614 9.460742,3.699706 9.635728,3.699706 C9.810714,3.699706 9.985728,3.629979 10.125168,3.48916 L10.475168,3.13916 C12.014608,1.59972 14.535868,1.59972 16.110868,3.13916 C17.650308,4.64444 17.650308,7.16416 16.110868,8.73916 L16.11063,8.7393 Z"
                      id="Fill-1"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const AutomatedTimesheets = () => (
  <svg
    width="13px"
    height="23px"
    viewBox="0 0 13 23"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>D88FAF4E-9082-4B64-967D-C4BEA65FF2A9SVG</title>
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Atto-/-Time-tracking-for-construction-companies"
        transform="translate(-164.000000, -6298.000000)"
      >
        <g id="Group-38" transform="translate(150.000000, 5671.000000)">
          <g id="Group-5" transform="translate(0.000000, 230.000000)">
            <g id="subtittle-+-copy" transform="translate(0.000000, 370.000000)">
              <g id="Group" transform="translate(0.000000, 18.000000)">
                <g id="Automated-timesheets" transform="translate(14.000000, 9.000000)">
                  <g id="Group">
                    <circle
                      id="Oval-9"
                      stroke="#000000"
                      strokeWidth="1.6"
                      cx="6.4"
                      cy="8.8"
                      r="5.6"
                    />
                    <path
                      d="M6.4,0.6 C6.73137085,0.6 7,0.86862915 7,1.2 L7,2.4 C7,2.73137085 6.73137085,3 6.4,3 C6.06862915,3 5.8,2.73137085 5.8,2.4 L5.8,1.2 C5.8,0.86862915 6.06862915,0.6 6.4,0.6 Z"
                      id="Rectangle-4"
                      fill="#000000"
                      transform="translate(6.400000, 1.800000) scale(-1, 1) translate(-6.400000, -1.800000) "
                    />
                    <circle id="Oval-9" fill="#000000" cx="6.4" cy="8.8" r="1" />
                    <rect
                      id="Rectangle-11"
                      fill="#000000"
                      transform="translate(6.400000, 0.600000) rotate(-270.000000) translate(-6.400000, -0.600000) "
                      x="5.8"
                      y="-1.2"
                      width="1.2"
                      height="3.6"
                      rx="0.6"
                    />
                  </g>
                  <rect
                    id="Rectangle-11"
                    fill="#000000"
                    transform="translate(6.400000, 18.400000) rotate(-270.000000) translate(-6.400000, -18.400000) "
                    x="5.6"
                    y="12"
                    width="1.6"
                    height="12.8"
                    rx="0.8"
                  />
                  <rect
                    id="Rectangle-11"
                    fill="#000000"
                    transform="translate(6.400000, 21.600000) rotate(-270.000000) translate(-6.400000, -21.600000) "
                    x="5.6"
                    y="15.2"
                    width="1.6"
                    height="12.8"
                    rx="0.8"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const RespondToAbsenteeism = () => (
  <svg
    width="24px"
    height="22px"
    viewBox="0 0 24 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Respond to Absenteeism</title>
    <g id="WEB-DESIGN" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Atto-/-Time-tracking-for-Painting"
        transform="translate(-158.000000, -4596.000000)"
        fill="#000000"
        stroke="#000000"
        strokeWidth="0.5"
      >
        <g id="Group-56" transform="translate(150.000000, 4287.000000)">
          <g id="Group-37" transform="translate(0.000000, 280.000000)">
            <g id="subtittle-+" transform="translate(0.000000, 2.000000)">
              <g id="Group" transform="translate(0.000000, 18.000000)">
                <g id="Emergency-call-outs" transform="translate(9.000000, 10.000000)">
                  <path
                    d="M4.295424,16.740416 L4.40392512,16.740416 L4.40392512,11.84736 C4.40392512,8.096256 7.44898112,5.0512 11.2000851,5.0512 C14.9511891,5.0512 17.9962451,8.096256 17.9962451,11.84736 L17.9962451,16.740416 L18.1047462,16.740416 C18.9744934,16.740416 19.735735,17.5016576 19.735735,18.3714048 L19.735735,19.5132898 C19.735735,19.785405 19.5178592,20.0024162 19.2466086,20.0024162 L3.15355264,20.0024162 C2.88143744,20.0024162 2.66442624,19.7845404 2.66442624,19.5132898 L2.66442624,18.3714048 C2.66442624,17.5016576 3.42566784,16.740416 4.29541504,16.740416 L4.295424,16.740416 Z M5.3288032,16.740416 L17.1264352,16.740416 L17.1264352,11.84736 C17.1264352,8.63968 14.4619552,5.9752 11.2000672,5.9752 C7.9381792,5.9752 5.3279072,8.63968 5.3279072,11.84736 L5.3279072,16.740416 L5.3288032,16.740416 Z M18.1055392,17.664416 L4.2954912,17.664416 C3.9148704,17.664416 3.5885024,17.990784 3.5885024,18.3714048 L3.5885024,19.0783938 L18.8117664,19.0783938 L18.8117664,18.3714048 C18.8117664,17.990784 18.4853984,17.664416 18.1047776,17.664416 L18.1055392,17.664416 Z"
                    id="Fill-1"
                  />
                  <path
                    d="M11.2,7.334208 C11.4721152,7.334208 11.6891264,7.55208384 11.6891264,7.8233344 C11.6891264,8.04121024 11.4712506,8.258208 11.2,8.258208 C9.2426208,8.258208 7.61152,9.8891968 7.61152,11.846688 C7.61152,12.1188032 7.39364416,12.3358144 7.1766464,12.3358144 C6.9045312,12.3358144 6.68752,12.1179386 6.68752,11.846688 C6.68752,9.40016 8.7534048,7.334208 11.2,7.334208 Z"
                    id="Fill-2"
                  />
                  <path
                    d="M10.765216,0.592368 C10.765216,0.37449216 10.9279654,0.1574944 11.2000896,0.1574944 C11.4722138,0.1574944 11.689216,0.37537024 11.689216,0.592368 L11.689216,2.93048 C11.689216,3.14835584 11.4713402,3.3653536 11.2000896,3.3653536 C10.9279744,3.3653536 10.765216,3.14747776 10.765216,2.93048 L10.765216,0.592368 Z"
                    id="Fill-3"
                  />
                  <path
                    d="M16.8,1.68009856 C17.0178758,1.78859968 17.126368,2.06071936 16.9627494,2.27773056 L15.8208646,4.28936256 C15.7123635,4.5072384 15.4402438,4.56147776 15.1681062,4.452112 C14.9502304,4.34361088 14.895991,4.0172384 15.0053568,3.7993536 L16.201472,1.8419744 C16.3108691,1.62497216 16.5829888,1.51648 16.8,1.68009856 Z"
                    id="Fill-4"
                  />
                  <path
                    d="M20.27984,5.594848 C20.4977158,5.48634912 20.7689664,5.54059835 20.9325984,5.75759744 C21.0410995,5.97547328 20.9325984,6.24672384 20.7147226,6.41035584 L18.7573434,7.55224064 C18.5394675,7.66074176 18.268217,7.60649128 18.104585,7.3894912 C17.9960838,7.17161536 18.0503343,6.846112 18.2673344,6.7367328 L20.2789664,5.594848 L20.27984,5.594848 Z"
                    id="Fill-5"
                  />
                  <path
                    d="M21.965216,10.922688 C22.1830918,10.922688 22.4000896,11.0854374 22.4000896,11.3575616 C22.4000896,11.6296858 22.1822138,11.846688 21.965216,11.846688 L19.627104,11.846688 C19.4092282,11.846688 19.1922304,11.6288122 19.1922304,11.3575616 C19.1922304,11.0854464 19.4101062,10.922688 19.627104,10.922688 L21.965216,10.922688 Z"
                    id="Fill-6"
                  />
                  <path
                    d="M5.437152,2.277632 C5.32865088,2.05975616 5.38290136,1.7885056 5.59990144,1.68 C5.81777728,1.51725056 6.08902784,1.62574944 6.25265984,1.84274944 L7.39454464,3.80012864 C7.50304576,4.01800448 7.44879528,4.34350784 7.2317952,4.45288704 C7.01391936,4.56138816 6.688416,4.50713768 6.5790368,4.2901376 L5.437152,2.2785056 L5.437152,2.277632 Z"
                    id="Fill-7"
                  />
                  <path
                    d="M1.52249216,5.7574496 C1.63099328,5.53957376 1.90311296,5.4853344 2.12012416,5.59470016 L4.13175616,6.73658496 C4.349632,6.84508608 4.40387136,7.17145856 4.2945056,7.38934336 C4.18600448,7.6072192 3.859632,7.66145856 3.6417472,7.5520928 L1.684368,6.410208 C1.46736576,6.24745856 1.3588736,5.9753344 1.52249216,5.7574496 Z"
                    id="Fill-8"
                  />
                  <path
                    d="M0.4348736,11.846688 C0.21699776,11.846688 0,11.6288122 0,11.3575616 C0,11.0854464 0.21787584,10.922688 0.4348736,10.922688 L2.7729856,10.922688 C2.99086144,10.922688 3.2078592,11.0854374 3.2078592,11.3575616 C3.2078592,11.6296858 2.98998336,11.846688 2.7729856,11.846688 L0.4348736,11.846688 Z"
                    id="Fill-9"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
